import {observer} from "mobx-react";
import {useStore} from "../../stores/Store";
import AccordionOverviewCard from "./AccordionOverviewCard/AccordionOverviewCard";
import img from '../../assets/img/pigini_p1.jpeg'
import Grid from "@mui/material/Unstable_Grid2";
import {
    Box, Button,
    CircularProgress, Divider,
    Fab,
    IconButton,
    SwipeableDrawer,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import AccordionsFilter from "./AccordionsFilter/AccordionsFilter";
import {ArrowBackIosNew, FilterAlt} from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import rentalImage from '../../assets/img/rental.jpg'
import purchaseImage from '../../assets/img/purchase.jpg'
import AccordionFilterSummary from "./AccordionFilterSummary";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import AccordionCreateDialog from "./AccordionCreateDialog";
import {EntityStatus} from "../../models/EntityStatus";
import ShareIcon from "@mui/icons-material/Share";
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import {useNavigate} from "react-router-dom";
interface Props {
    mode: 'rent' | 'buy'
}

export default observer(function AccordionsPage({mode}: Props){
    const {AccordionStore, UserStore, LanguageStore} = useStore();
    const {filteredAccordions, isLoading, resetFilter, isFilterSet, setMode} = AccordionStore
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [drawerIsOpen, setDrawerIsOpen] = useState<boolean>(false)
    const navigate = useNavigate();

    const toggleDrawer = () => setDrawerIsOpen(!drawerIsOpen)
    const handleCloseDrawer = () => setDrawerIsOpen(false)
    const handleOpenDrawer = () => setDrawerIsOpen(true)

    useEffect(() => {
        setMode(mode)
        resetFilter();
    }, []);

    const renderLoadingScreen = () => (
        isLoading ?
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100vh" }}
            >
                <CircularProgress color={'secondary'} />
            </Box>
            :
            null
    );

    const renderDesktopFilter = () => !isLoading && !isMobile ?
        <Grid xs={12} sm={2}><AccordionsFilter /></Grid> :
        null;

    const renderMobileFilter = () => !isLoading && isMobile ? (
        <>
            <Fab
                onClick={toggleDrawer}
                sx={{position: 'fixed', bottom: 16, left: 16}}
                color={'secondary'}
                variant={'circular'}
            >
                <FilterAlt />
            </Fab>
           <SwipeableDrawer
               anchor={'left'}
               open={drawerIsOpen}
               onClose={handleCloseDrawer}
               onOpen={handleOpenDrawer}
           >
               <IconButton
                   sx={{position: 'absolute', right: 16, top: 7}}
                   onClick={handleCloseDrawer}
                   color={(isFilterSet()) ? 'success' : 'default'} centerRipple={true}
               >
                   {(isFilterSet()) ? <CheckIcon /> : <CloseIcon />}
               </IconButton>
               <Grid container sx={{width: '98%', p:1, display: 'flex', textAlign: 'center'}}>
                   <AccordionsFilter />
               </Grid>
           </SwipeableDrawer>
        </>
    ) : null;

    const renderAccordionsFilterSummary = () => !isLoading && !isMobile ? <AccordionFilterSummary /> : null;

    const renderCreateAccordionDialog = () => !isLoading && UserStore.isLoggedIn ?
        <Grid sx={{textAlign: 'center', pr: 2, pb: 2}} xs={12}>
            <AccordionCreateDialog />
        </Grid> :
        null

    return(
        <>
            <Box sx={{overflow: 'hidden', position: 'relative'}} >
                <Box sx={{display: 'flex'}}>
                    {
                        isMobile ?
                            <IconButton onClick={() => navigate('/Accordions')} >
                                <ArrowBackIosNew />
                            </IconButton> :
                            <Button
                                startIcon={<ArrowBackIosNew />}
                                onClick={() => navigate('/Accordions')}
                            >
                                {LanguageStore.currentLanguageMessages.GeneralComponentLabels.backButtonLabel}
                            </Button>
                    }
                    <Typography variant={'h5'} sx={{m: 3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                        {(mode === 'buy') ?
                            <><ShoppingBagOutlinedIcon sx={{mr: 2}} /> {LanguageStore.currentLanguageMessages.AccordionsPage.titleToBuy}</>:
                            <><ShareIcon sx={{mr: 2}} />{LanguageStore.currentLanguageMessages.AccordionsPage.titleToRent}</>
                        }
                    </Typography>
                </Box>
                <img 
                    src={(mode === 'buy') ? purchaseImage : rentalImage}
                    style={{
                        position: 'absolute',
                        top: -150,
                        left: 0,
                        width: '100%',
                        objectFit: 'cover',
                        maskImage: `linear-gradient(to left, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 0) ${isMobile ? '40%' : '100%'})`,
                        WebkitMaskImage: `linear-gradient(to left, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 0) 100%)`,
                        zIndex: -1,
                    }}
                />
            </Box>
            <Divider />
            { renderLoadingScreen() }
            { renderMobileFilter() }
            { renderAccordionsFilterSummary() }
            { renderCreateAccordionDialog() }
            {
                !isLoading && <Grid container justifyContent={'center'} sx={{mr: 4, ml: 4, mb: 4, mt: 1, textAlign: 'center'}} >
                    { renderDesktopFilter() }
                    <Grid xs={12} sm={10}>
                        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center'}}>
                            {
                                filteredAccordions.map(accordion => (UserStore.isLoggedIn || accordion.status === EntityStatus.created) &&
                                    <AccordionOverviewCard key={accordion.id} accordion={accordion} image={img} />
                                )
                            }
                        </Box>
                    </Grid>
                </Grid>
            }
        </>
    )
})